<div class="modal-header">
  <h4 class="modal-title synchpc-primary" id="modal-title">Update Node Network</h4>
  <i style="z-index: 1" class="bi bi-x-lg text-danger" color="warn" (click)="onClose()" title="Close"></i>
</div>
<div class="modal-body text-grey">
  <form action="" [formGroup]="updateNodeForm">
    <ng-container *ngIf="toShowDeploymentSpecificFields">
      <mat-form-field>
        <mat-label>Workstation Name</mat-label>
        <input matInput
               title="Workstation Name"
               formControlName="wsName"
               placeholder="Workstation Name" />
        <mat-error *ngIf="
            updateNodeForm.get('wsName').touched &&
            updateNodeForm.get('wsName').errors?.pattern
          ">
          Invalid Workstation Name.
        </mat-error>
      </mat-form-field>
      <mat-form-field>
        <mat-label>MAC Address</mat-label>
        <input matInput
               title="MAC Address"
               formControlName="macAddress"
               placeholder="MAC Address" />
        <mat-error *ngIf="
            updateNodeForm.get('macAddress').touched &&
            updateNodeForm.get('macAddress').errors?.pattern
          ">
          Invalid Mac Address.
        </mat-error>
      </mat-form-field>
      <mat-form-field>
        <mat-label>External IP</mat-label>
        <input matInput
               title="External IP"
               formControlName="publicIp"
               placeholder="External IP" />
        <mat-error *ngIf="
            updateNodeForm.get('publicIp').touched &&
            updateNodeForm.get('publicIp').errors?.pattern
          ">
          Invalid IP.
        </mat-error>
      </mat-form-field>
      <mat-form-field>
        <mat-label>IP Address</mat-label>
        <input matInput
               title="IP Address"
               formControlName="privateIp"
               placeholder="IP Address" />
        <mat-error *ngIf="
            updateNodeForm.get('privateIp').touched &&
            updateNodeForm.get('privateIp').errors?.pattern
          ">
          Invalid IP.
        </mat-error>
      </mat-form-field>
    </ng-container>

    <mat-form-field appearance="fill">
      <mat-label>Gateways</mat-label>
      <mat-select formControlName="gateway">
        <mat-option value="-1">None</mat-option>
        <mat-option *ngFor='let gw of gateways' [value]="gw">{{ gw }}</mat-option>
      </mat-select>
      <mat-error *ngIf='updateNodeForm.get("gateway").touched && updateNodeForm.get("gateway").errors'>Required</mat-error>
    </mat-form-field>
  </form>
  <mat-error>Editing node name will affect usage graph.</mat-error>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-outline-secondary" (click)="onClose()">Close</button>
  <button type="button" class="btn btn-primary" (click)="onSubmit()">Submit</button>
</div>
<ngx-spinner
  bdColor="rgba(0,0,0,0)"
  size="default"
  zIndex="1"
  color="var(--s-primary-color)"
  type="ball-spin"
  [fullScreen]="false"
  name="updateNode"
><p class="pleaseWait text-grey">Please wait ...</p></ngx-spinner>
